import React from 'react'
import { useIntercom } from 'react-use-intercom'

import Button from '@/components/Button'


export default function RequestAccountCta() {
  const { showNewMessages } = useIntercom()
  return (
    <div className="py-8 bg-gray-900">
      <div className="container flex items-center justify-center">
        <Button onClick={() => showNewMessages('I would like to use a staking account.')} modifier="secondary" className="px-12 py-4">
          Request an account
        </Button>
      </div>
    </div>
  )
}